import { getCookie, setCookie } from '../helpers'

$(() => {
    
    // Show banner
	$('.header-banner').each(event => {
		const id = $(event.target).attr('data-id')
		const banner = getCookie(id)

		if (!banner) {
			$(event.target).slideDown('slow')
		}
	})

	// Dismiss banner
	$('.header-banner .close-button').on('click', event => {
		const parent = $(event.target).closest('.header-banner')
		const id = parent.attr('data-id')

		setCookie(id, 1, 30)

		$('.header-banner').each(event => {
			$(event.target).slideUp()
		})
	})
})